var _rect, _g, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccessPopupIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 458,
    height: 160,
    viewBox: "0 0 458 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_20971_24856",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 458,
    height: 107
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 458,
    height: 107,
    rx: 24,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_20971_24856)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 229,
    cy: -41,
    rx: 337,
    ry: 147,
    fill: "#EAFAEF"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 175,
    y: 53,
    width: 108,
    height: 107,
    rx: 53.5,
    fill: "#24A147"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M221.667 124L207 109.106L212.133 103.894L221.667 113.574L245.867 89L251 94.2128L221.667 124Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessPopupIcon);
export default __webpack_public_path__ + "static/media/successPopupIcon.76ad802988a31e87a55f3f0eba0d3b56.svg";
export { ForwardRef as ReactComponent };